import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function GameSessionDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"Jackpot Details"}
                            endpoint={"jackpot/read"}
                            relations={["campaign"]} />
}

export default GameSessionDetailsPage;